import { createContext, useContext } from "react";

export const GuideContext = createContext({});

export function useGuide() {
  return useContext(GuideContext);
}
